//Change price on variant change
var productData = JSON.parse(document.getElementsByClassName('product-json')[0].textContent);
var defaultVariant = JSON.parse(document.getElementsByClassName('default-variant-json')[0].textContent);
var currency_symbol = document.querySelector('#currency_symbol').textContent;

if (defaultVariant) {
    options = {
        option1: defaultVariant.option1,
        option2: defaultVariant.option2,
        option3: defaultVariant.option3
    }
}

function changeVariant(index, value) {
    var variants = productData.variants;
    var activeVariant;
    var selector = document.getElementById('ProductSelect-product-template');

    options[index] = value;

    for (var i = 0; i < variants.length; i++) {
        if (variants[i].option1 == options.option1 && variants[i].option2 == options.option2 && variants[i].option3 == options.option3) {
            activeVariant = variants[i];
            break;
        }
    }

    if (activeVariant != undefined) {

        selector.querySelector('[selected="selected"').removeAttribute('selected');
        selector.querySelector('[value="' + activeVariant.id + '"]').setAttribute('selected', 'selected');

        // update pricing
        document.querySelector('.product-single__meta .product__price dl.price').classList.toggle('price--on-sale', activeVariant.compare_at_price != null);
        document.querySelector('.product-single__meta .save__btn').classList.toggle('price--on-sale', activeVariant.compare_at_price != null);
        if (activeVariant.compare_at_price != null) {
            document.getElementsByClassName('price-item--sale')[0].innerHTML = '<span class="money">' + currency_symbol + (activeVariant.price / 100).toFixed(2) + '</span>';
            document.getElementsByClassName('price-item--regular')[1].innerHTML = '<span class="money">' + currency_symbol + (activeVariant.compare_at_price / 100).toFixed(2) + '</span>';
            document.getElementsByClassName('save__btn')[0].innerHTML = 'Save <span class="money">' + currency_symbol + ((activeVariant.compare_at_price - activeVariant.price) / 100).toFixed(2) + '</span>';
        } else {
            document.getElementsByClassName('price-item--regular')[0].innerHTML = '<span class="money">' + currency_symbol + (activeVariant.price / 100).toFixed(2) + '</span>';
        }

        // move slides to match featured image of variant (if applicable)
        if (activeVariant.featured_image != null) {
            var actmediaID = activeVariant.featured_media.id,
                slides = document.getElementsByClassName('thumbsSlider_Sec')[0].getElementsByClassName('swiper-slide');
                
            for (var i = 0; i < slides.length; i++) {
                var mediaID = slides[i].dataset['id'];
                if(mediaID == actmediaID) {
                    swiper2.slideTo( i );
                    break;
                }
            }
        }

        console.log('yes option');
        $('button.btn.product-form__cart-submit').css('pointer-events', 'all');
        $('button.btn.product-form__cart-submit').css('opacity', '1');
        $('button.btn.product-form__cart-submit').css('filter', 'grayscale(0)');
    } else {
        console.log('no option');
        $('button.btn.product-form__cart-submit').css('pointer-events', 'none');
        $('button.btn.product-form__cart-submit').css('opacity', '0.7');
        $('button.btn.product-form__cart-submit').css('filter', 'grayscale(1)');
    }

}

$(document).ready(function () {
    //Add to cart
    var upsellModal = document.querySelector('upsell-modal');

    function addItemToCart(data) {
        var params = {
            url: '/cart/add.js',
            data: $(data).serialize(),
            dataType: 'json'
        };
        console.log(params);

        $.post(params, function (data) {
                var event = new CustomEvent('cartUpdated', {
                    "detail": {
                        "data": data,
                        "form": $(data).get(0)
                    }
                });
                handleButtonLoadingState(false);
                document.dispatchEvent(event);
            })
            .then(
                function () {
                    if (!upsellModal) {
                        switch (window.cta_target) {
                            case 'bundle':
                                window.location.href = window.location.origin + '/pages/bundle-and-save-general-product';
                                break;
                            case 'checkout':
                                window.location.href = window.location.origin + '/checkout';
                                break;
                            case 'cart':
                                window.location.href = window.location.origin + '/cart';
                                break;
                            default:
                                reBuildCart();
                                open_cart_drawer();
                        }
                    }
                }
            )
            .catch((e) => {
                var event = new CustomEvent('errorEvent', {
                    "detail": e
                });
                handleButtonLoadingState(false);
                document.dispatchEvent(event);
            });

    }

    if (upsellModal) {
        document.addEventListener('cartUpdated', function (e) {
            const body = {
                sections: upsellModal.getSectionsToRender().map((section) => section.section)
            };
            $.get(e.detail.data.url, body, function (data) {
                upsellModal.renderContents(data);
            })
        });
    }

    $('.product-form').on(
        'submit',
        function (evt) {
            if (!ajax) return;
            var validated = true;
            var imageAttrContainers = $(this).find('.uploadkit-attribute-container');

            if (window.UploadKit && imageAttrContainers.length > 0) {
                for (var i = 0; i < imageAttrContainers.length; i++) {
                    if (imageAttrContainers[i].dataset['required'] === 'false') {
                        continue;
                    }
                    if (imageAttrContainers[i].innerHTML === '') {
                        validated = false;
                    }
                }

            }

            evt.preventDefault();
            if (validated) {
                this.$previouslyFocusedElement = $(':focus');

                handleButtonLoadingState(true);
                var $data = $('.product-form');
                addItemToCart($data);
            } else {
                console.log($('.product-form'));
                $('.mb_container').fadeIn();
                // alert('Please upload image first');
            }
        }
    );

    //Change upload image text based on screenwidth - this does not display due to excecution order
    if ($(window).width() <= 759) {
        $('DIV.uploadkit-uploader > BUTTON.uploadkit-button').text('Tap to Upload Photo').val('Tap to Upload Photo');
    }

    //Change selected variant and quantity
    $(function () {
        $('.cp-size-option').on('click', function () {
            var value = $(this).data('value'),
                index = $(this).closest('.cp-size-select-wrapper').find('.single-option-selector').attr('data-index');
            //Visual
            // $(this).closest('.cp-size-select-wrapper').find('.single-option-selector').val(value).trigger('change');
            $(this).closest('.cp-size-select-wrapper').find('.cp-size-option').removeClass('selected');
            $(this).addClass('selected');

            changeVariant(index, value);
        });

        $('.cp-colour-option').on('click', function () {
            var value = $(this).data('value'),
                index = $(this).closest('.cp-size-select-wrapper').find('.single-option-selector').attr('data-index');

            // $(this).closest('.cp-colour-select-wrapper').find('.single-option-selector').val(value).trigger('change');
            $(this).closest('.cp-colour-select-wrapper').find('.cp-colour-option').removeClass('selected');
            $(this).addClass('selected');

            changeVariant(index, value);
        });

        $('.single-option-selector').on('change', function () {
            var value = $(this).find(":selected").val(),
                index = $(this).attr('data-index');

            changeVariant(index, value);
        });

        $(document).on('blur', '.product-form__input--quantity', function () {
            var value = $(this).val();
            if (!value || value < 1) {
                $(this).val(1);
                $(this).trigger('change');
            }
        });

        $(document).on('click', '.cp-product-quantity-wrapper .control', function () {
            var input = $(this).closest('.cp-product-quantity-wrapper').find('.product-form__input--quantity'),
                value = parseInt(input.val());
            if (input.prop('disabled')) {
                return;
            }
            if ($(this).hasClass('more')) {
                input.val(value + 1);
            } else {
                if (value <= 1) return;
                input.val(value - 1);
            }
            input.trigger('change');

            if ($('form.cart').length > 0) {
                updateCartQuantity(input, input.val());
            }
        });

        function updateCartQuantity(el, value) {
            var id = el.data('id');
            $('input[id="' + id + '"').val(value).trigger('change');
            el.val(value);
        }

        // Tabbed description
        $('.cp-tabbed-description .tabs-wrapper .tab').on('click', function () {
            var $parent = $(this).closest('.cp-tabbed-description'),
                tab = $(this).data('tab');

            $parent.find('.tabs-wrapper .tab').removeClass('active');
            $(this).addClass('active');
            $parent.find('.tab-content').hide();
            $parent.find('.tab-content.' + tab).show();
        });

        // Overlays
        $('.cp-product-overlay-open').on('click', function (e) {
            e.preventDefault();
            var overlay = $(this).data('overlay');
            $('.cp-product-overlay-wrapper').fadeIn('fast', function () {
                $('.cp-product-overlay-container.' + overlay).fadeIn('fast');
            });
            $("html, body").css({
                height: '100%',
                overflow: 'hidden'
            });
            return false;
        });

        $('.cp-product-overlay-wrapper .close-btn').on('click', function () {
            $('.cp-product-overlay-wrapper').fadeOut('fast');
            $('.cp-product-overlay-container').fadeOut('fast');
            $("html, body").css({
                height: '',
                overflow: ''
            });
        });

    });
});